import { Presentation, Menu, BookPlus, Megaphone, Users, ShieldCheck, Telescope, CircleUser } from "lucide-react";
import { Link, Outlet } from "react-router-dom";
import {
    Sheet,
    SheetContent,
    SheetTrigger,
} from "@/components/ui/sheet"

import { useState } from "react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";

const walletButtonStyles = {
    border: "1px solid black", // !important is not supported in CSSProperties
    color: "black",
};

interface NavigationElement {
    to: string,
    toString: string,
    icon: React.ReactElement,
    additionalComponents?: React.ReactElement,
    disabled?: boolean,
}

const Layout = () => {

    const [selection, setSelection] = useState<number>(0);

    function handleClick(id: number) {
        setSelection(id)
    }

    const navigations: NavigationElement[] = [
        {
            to: "/app/explore",
            toString: "Explorer",
            icon: <Telescope className="h-4 w-4" />,
        },
        {
            to: "/app/register-publisher",
            toString: "Publishers",
            icon: <BookPlus className="h-4 w-4" />,
        },
        {
            to: "/app/manage-publisher",
            toString: "Manage Publishers",
            icon: <Users className="h-4 w-4" />,
        },
        {
            to: "/app/register-ad-campaign",
            toString: "Ad Campaign",
            icon: <Megaphone className="h-4 w-4" />,
        },
        {
            to: "/app/manage-ad-campaign",
            toString: "Manage Ad Campaign",
            icon: <Users className="h-4 w-4" />,
        },
        {
            to: "#",
            toString: "Validators",
            additionalComponents: <div className="text-xxs border text-slate-500 border-slate-500 rounded-md p-0.5">SOON</div>,
            icon: <ShieldCheck className="h-4 w-4" />,
            disabled: true
        },
    ]

    return (
        <div className="grid min-h-screen w-full md:grid-cols-[220px_1fr] lg:grid-cols-[280px_1fr]">
            <div className="hidden border-r md:block bg-gray-50">
                <div className='flex h-full max-h-screen flex-col gap-2'>
                    <div className='flex h-14 items-center border-b px-4 lg:h-[60px] lg:px-6'>
                        <Link to="/" className="flex items-center gap-2 font-semibold">
                            <Presentation className="h-6 w-6" />
                            <span className="">Billboard</span>
                        </Link>
                    </div>
                    <div className="flex-1">
                        <nav className="grid items-start px-2 text-sm font-medium lg:px-4">
                            {navigations.map((value, index) => (

                                <Link
                                    key={index}
                                    to={!value.disabled ? value.to : "#"}
                                    className={`flex items-center gap-3 rounded-lg ${!value.disabled ? (selection == index + 1 ? "bg-slate-200 text-black" : "hover:text-black text-gray-500") : "text-gray-500"} px-3 py-2 transition-all`}
                                    onClick={() => !value.disabled && handleClick(index + 1)}
                                >
                                    {value.icon}
                                    {value.toString}
                                    {Object.keys(value).includes("additionalComponents") && value.additionalComponents}
                                </Link>
                            ))}
                        </nav>
                    </div>
                    <div className="mt-auto p-4">
                        <Link
                            to="/app/account"
                            className={`mx-[-0.65rem] flex items-center gap-4 rounded-xl px-3 py-2 transition-all`}
                        >
                            <CircleUser className="h-10 w-10 " />
                            <span className="hover:text-black text-gray-500">Account </span>
                        </Link>

                    </div>
                </div>
            </div>
            <div className='flex flex-col'>
                <header className="flex h-14 items-center gap-4 border-b bg-muted/40 px-4 lg:h-[60px] lg:px-6 bg-gray-50">
                    <Sheet>
                        <SheetTrigger asChild>
                            <button
                                className="shrink-0 md:hidden"
                            >
                                <Menu className="h-5 w-5" />
                                <span className="sr-only">Toggle navigation menu</span>
                            </button>
                        </SheetTrigger>
                        <SheetContent side="left" className="flex flex-col bg-gray-50">
                            <nav className="grid gap-2 text-lg font-medium">
                                <Link
                                    to="/"
                                    className="flex items-center gap-2 text-lg font-semibold h-6 w-6"
                                >
                                    <Presentation className="h-6 w-6" />
                                </Link>
                                {navigations.map((value, index) => (

                                    <Link
                                        key={index}
                                        to={!value.disabled ? value.to : "#"}
                                        className={`mx-[-0.65rem] flex items-center gap-4 rounded-xl ${!value.disabled ? (selection == index + 1 ? "bg-slate-200 text-black" : "hover:text-black text-gray-500") : "text-gray-500"} px-3 py-2 transition-all`}
                                        onClick={() => !value.disabled && handleClick(index + 1)}
                                    >
                                        {value.icon}
                                        {value.toString}
                                        {Object.keys(value).includes("additionalComponents") && value.additionalComponents}
                                    </Link>
                                ))}
                            </nav>
                            <div className="mt-auto">
                                <Link
                                    to="/app/account"
                                    className={`mx-[-0.65rem] flex items-center gap-4 rounded-xl px-3 py-2 transition-all`}
                                >
                                    <CircleUser className="h-10 w-10 " />
                                    <span className="hover:text-black text-gray-500">Account </span>
                                </Link>
                            </div>
                        </SheetContent>
                    </Sheet>
                    <div className="w-full flex-1">

                    </div>
                    <WalletMultiButton style={walletButtonStyles} />
                </header>
                <main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}

export default Layout